export const pdfImportEndpoints = (builder) => ({
    // Process PDF and extract JSON data
    processPdf: builder.mutation({
        query: (formData) => ({
            url: '/pdf-import/process-pdf',
            method: 'POST',
            body: formData,
            // Header Content-Type is handled automatically by the browser for FormData
        }),
        invalidatesTags: ['Policy'], // Adjust tag if needed
    }),

    // Import the extracted JSON data into the database
    importPdfJson: builder.mutation({
        query: (jsonData) => ({
            url: '/pdf-import/import-json',
            method: 'POST',
            body: jsonData,
        }),
        invalidatesTags: ['Policy', 'Customer', 'Agency', 'GroupMaster', 'Branch'],
    }),

    // NEW: Check if policies already exist in DB
    checkExistingPolicies: builder.mutation({
        query: (policyNumbers) => ({
            url: '/pdf-import/check-existing',
            method: 'POST',
            body: { policyNumbers },
        }),
    }),
    checkPlans: builder.mutation({
        query: (plans) => ({
            url: '/pdf-import/check-plans',
            method: 'POST',
            body: { plans },
        }),
    }),
    checkBranches: builder.mutation({
        query: (branchNames) => ({
            url: '/pdf-import/check-branches',
            method: 'POST',
            body: { branchNames },
        }),
    }),
    sendProductRequest: builder.mutation({
        query: (missingPlans) => ({
            url: '/pdf-import/send-product-request',
            method: 'POST',
            body: { missingPlans },
        }),
    }),
    exportFailedPdfImport: builder.mutation({
        query: (batchId) => ({
            url: `/pdf-import/export-failed/${batchId}`,
            method: 'GET',
            responseHandler: (response) => response.blob(),
        }),
    }),
});
